import StakeService from '@/api/StakeService'
import UtilService from '@/utils/UtilService'
import UserService from '@/api/UserService'
const state = {
  resetZoom: false,
  binaryData: [],
  userStaking: [],
  userRefStaking: [],
  comStakingHistory: {},
  comStakingBinaryHistory: {},
  comDailyHistory: {},
  stakingMatrixInfo: {},
  comGlobalBonusHistory: {},
  comLeaderBonusHistory: {},
  comFundCareHistory: {},
  simpleChart: true,
  isLoadingChart: false
}

const getters = {
  binaryData: state => state.binaryData,
  comStakingHistory: state => state.comStakingHistory,
  comStakingBinaryHistory: state => state.comStakingBinaryHistory,
  comDailyHistory: state => state.comDailyHistory,
  stakingMatrixInfo: state => state.stakingMatrixInfo,
  comGlobalBonusHistory: state => state.comGlobalBonusHistory,
  comLeaderBonusHistory: state => state.comLeaderBonusHistory,
  comFundCareHistory: state => state.comFundCareHistory,
  resetZoom: state => state.resetZoom,
  simpleChart: state => state.simpleChart,
  isLoadingChart: state => state.isLoadingChart
}

const mutations = {
  SET_IS_LOAD_CHART: (state, data) => {
    state.isLoadingChart = data
  },
  SET_SWITCH_CHART: (state) => {
    state.simpleChart = !state.simpleChart
  },
  SET_SWITCH_CHART_BOOLEAN: (state, data) => {
    state.simpleChart = data
  },
  SET_RESET_ZOOM: (state, data) => {
    state.resetZoom = data
  },
  SET_BINARY_DATA: (state, data) => {
    state.binaryData = data
  },
  SET_USER_STAKING: (state, data) => {
    state.userStaking = data
  },
  SET_USER_REF_STAKING: (state, data) => {
    state.userRefStaking = data
  },
  SET_COM_STAKING_HISTORY: (state, data) => {
    state.comStakingHistory = data
  },
  SET_COM_BINARY_STAKING_HISTORY: (state, data) => {
    state.comStakingBinaryHistory = data
  },
  SET_COM_STAKING_DAILY_HISTORY: (state, data) => {
    state.comDailyHistory = data
  },
  SET_STAKING_MATRIX_INFO: (state, data) => {
    state.stakingMatrixInfo = data
  },
  SET_COM_GLOBAL_BONUS_STAKING_HISTORY: (state, data) => {
    state.comGlobalBonusHistory = data
  },
  SET_COM_LEADER_BONUS_STAKING_HISTORY: (state, data) => {
    state.comLeaderBonusHistory = data
  },
  SET_COM_FUND_CARE_STAKING_HISTORY: (state, data) => {
    state.comFundCareHistory = data
  }
}

const actions = {
  setLoadChart ({ commit }, data) {
    commit('SET_IS_LOAD_CHART', data)
  },
  setResetZoom ({ commit }, data) {
    commit('SET_RESET_ZOOM', data)
  },
  setSwitchChartBool ({ commit }, data) {
    commit('SET_SWITCH_CHART_BOOLEAN', data)
  },
  setSwitchChart ({ commit }) {
    commit('SET_SWITCH_CHART')
  },
  getComGlobalBonusHistory ({ commit }, page) {
    return new Promise((resolve, reject) => {
      StakeService.getComGlobalBonusHistory(page).then(rs => {
        const data = rs.data || {}
        commit('SET_COM_GLOBAL_BONUS_STAKING_HISTORY', UtilService.transformComGlobalBonusHistory(data) || [])
        const pagination = {
          currentPage: data.currentPage,
          totalPage: data.totalPages,
          totalRecord: data.totalRecords
        }
        this.dispatch('setComGlobalPagination', pagination)
        resolve(rs.status)
      })
    })
  },
  getComLeaderBonusHistory ({ commit }, page) {
    return new Promise((resolve, reject) => {
      StakeService.getComLeaderBonusHistory(page).then(rs => {
        const data = rs.data || {}
        commit('SET_COM_LEADER_BONUS_STAKING_HISTORY', UtilService.transformComLeaderBonusHistory(data) || [])
        const pagination = {
          currentPage: data.currentPage,
          totalPage: data.totalPages,
          totalRecord: data.totalRecords
        }
        this.dispatch('setComLeaderBonusPagination', pagination)
        resolve(rs.status)
      })
    })
  },
  getComFundCareHistory ({ commit }, page) {
    return new Promise((resolve, reject) => {
      StakeService.getComFundCareHistory(page).then(rs => {
        const data = rs.data || {}
        commit('SET_COM_FUND_CARE_STAKING_HISTORY', UtilService.transformComFundCareHistory(data) || [])
        const pagination = {
          currentPage: data.currentPage,
          totalPage: data.totalPages,
          totalRecord: data.totalRecords
        }
        this.dispatch('setComFundCarePagination', pagination)
        resolve(rs.status)
      })
    })
  },
  cancelStake (__, data) {
    return new Promise((resolve, reject) => {
      StakeService.cancelStake(data.packageId).then(rs => {
        resolve(rs.status)
      })
    })
  },
  getBinaryData ({ commit }, code) {
    return new Promise((resolve, reject) => {
      UserService.getUserMatrix(code).then(rs => {
        const data = rs.data || []
        for (let i = 0; i < data.length; i++) {
          const newTxt = data[i].username
          data[i].isIn = data[i].parentCode !== data[i].refCode
          data[i].beautyAddress = newTxt
          data[i].key = data[i].code
          data[i].parent = data[i].parentCode
          data[i].stt = i + 1
        }
        commit('SET_BINARY_DATA', data)
        resolve(true)
      }).catch(e => {
        commit('SET_BINARY_DATA', [])
        resolve(false)
      })
    })
  },
  getStakingComHistory ({ commit }, page) {
    return new Promise((resolve, reject) => {
      StakeService.getComHistory(page).then(rs => {
        const data = rs.data || []
        commit('SET_COM_STAKING_HISTORY', UtilService.transformComStakingHistory(data) || [])
        const pagination = {
          currentPage: data.currentPage,
          totalPage: data.totalPages,
          totalRecord: data.totalRecords
        }
        this.dispatch('setComPagination', pagination)
        resolve(rs.status)
      })
    })
  },
  getStakingBinaryComHistory ({ commit }, page) {
    return new Promise((resolve, reject) => {
      StakeService.getComBinaryHistory(page).then(rs => {
        const data = rs.data || []
        commit('SET_COM_BINARY_STAKING_HISTORY', UtilService.transformUserStaking(data) || [])
        const pagination = {
          currentPage: data.currentPage,
          totalPage: data.totalPages,
          totalRecord: data.totalRecords
        }
        this.dispatch('setComRefPagination', pagination)
        resolve(rs.status)
      })
    })
  },
  getStakingDailyHistory ({ commit }, page) {
    return new Promise((resolve, reject) => {
      StakeService.getDailyProfits(page).then(rs => {
        const data = rs.data || []
        commit('SET_COM_STAKING_DAILY_HISTORY', UtilService.transformComDaily(data) || [])
        const pagination = {
          currentPage: data.currentPage,
          totalPage: data.totalPages,
          totalRecord: data.totalRecords
        }
        this.dispatch('setDailyPagination', pagination)
        resolve(rs.status)
      })
    })
  },

  getComSummaryBonus ({ commit }, data) {
    return new Promise((resolve) => {
      StakeService.getComSummaryBonus(data).then(rs => {
        const data = rs.data || []
        this.dispatch('setComSummaryBonus', data)
        console.log(data)
        resolve(data)
      })
    })
  }
}

export default { state, getters, mutations, actions }
